

















































































































import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue'
import ErrorToaster from '@/views/app/ErrorToaster.vue'
import {User} from '@/models/User'
import {NOTARY} from '@/api/NOTARY'

export default {
  name: 'SimplePaginationTable',
  components: {ConfirmDialog, ErrorToaster},
  props: {
    disablePagination: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    headers: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    entityUrl: {
      type: String,
      required: true
    },
    banner: {
      type: String,
      default: () => {
        return
      }
    },
    editRouteName: {
      type: String,
      required: true,
    },
    createRouteName: {
      type: String,
      required: true,
    },
    fetchParams: {
      type: Object,
      default: function () {
        return {}
      }
    },
    search: {
      type: String,
      default: function () {
        return ''
      }
    }
  },
  data () {
    return {
      selectedItem: {},
      confirmDialog: false,
      deleteError: {},
      customFetchError: {},
      itemsPerPage: 10,
      selectedClient: {},
      loading: true,
      items: [],
      rowsPerPageItems: [10, 20, 30, 40, 50],
    }
  },
  sockets: {
    new_activity: function (activity) {
      if (activity.entityName === this.$props.entityUrl) {
        this.customFetch()
      }
    }
  },
  computed: {
    computedHeaders: function () {
      return [
          ...this.headers,
        {
          text: 'Acciones',
          value: 'actions',
        }
      ]
    }
  },
  created() {
    this.customFetch()
  },
  methods: {
    editItem: function (item: { id: number }) {
      const id = String(item.id)
      this.$router.push({
        name: this.editRouteName,
        params: {id}
      })
    },
    createItem: function () {
      this.$router.push({
        name: this.createRouteName
      })
    },
    confirmDeletion: function () {
      if (this.selectedItem) {
        this.deleteItem(this.selectedItem)
      }
    },
    deleteItem: async function (item: User) {
      try {
        await NOTARY.delete(`${this.entityUrl}/${item.id}`)
        this.items = this.items.filter(c => {
          return c.id !== this.selectedItem?.id
        })
      } catch (e) {
        this.deleteError = e
      }
    },
    customFetch: async function () {
      this.loading = true
      try {
        const responses = await Promise.all([
          NOTARY.get(`${this.entityUrl}`, {
            params: {...this.fetchParams}
          })
        ])
        const response1 = responses[0]
        if (response1.data) {
          this.items = response1.data
        }
      } catch (e) {
        this.customFetchError = e
      }
      this.loading = false
    },
  },
  watch: {
    fetchParams: {
      handler: function () {
        this.customFetch()
      },
      deep: true
    }
  }
}
